module.exports = __webpack_public_path__ + "static/experts-make-the-case-for-college-menu-da703d171864107bf192d11465c32a72.jpg";